import React, { useState } from 'react';
import classNames from 'classnames';

interface ComponentProps {
  logo?: string | null;
  altText: string;
}

/**
 * CompanyLogo component renders the company logo in a fixed-width header slot.
 *
 * When `logo` is missing or fails to load, it renders an empty, transparent, fixed-width spacer so
 * the header layout does not shift. The slot width is fixed so menu items sit in the same place
 * for every company.
 *
 * @component
 * @param  props
 * @returns The rendered CompanyLogo component.
 */
const CompanyLogo: React.FC<ComponentProps> = ({ logo, altText }) => {
  const IMAGE_URL = process.env.REACT_APP_TPONE_LOGO_URL;
  const [failedLogo, setFailedLogo] = useState<string | null>(null);
  const showLogo = Boolean(logo) && logo !== failedLogo;

  return (
    <div
      className={classNames('company-logo', { empty: !showLogo })}
      aria-hidden={showLogo ? undefined : true}
    >
      {showLogo && (
        <img
          src={`${IMAGE_URL}//${logo}`}
          alt={`Company Logo ${altText}`}
          className="company-logo-img"
          onError={() => setFailedLogo(logo ?? null)}
        />
      )}
    </div>
  );
};

export default CompanyLogo;
